import { useQuery, useMutation, useQueryClient } from "react-query";

import { useApiService } from "../useApiService";
import { QUERY } from "../../constants/query";
import {
  AuthControllerService,
  LoginRequest,
  UserUpdateControllerService,
} from "../../services";

export const useGoogleAuth = () => {
  const { handleRequest } = useApiService();
  const queryKey = [QUERY.GOOGLE_AUTH];
  const query = useQuery(queryKey, () =>
    handleRequest(AuthControllerService.authControllerGoogleAuth())
  );
  return {
    ...query,
  };
};

export const useGoogleCallback = () => {
  const { handleRequest } = useApiService();
  const queryKey = [QUERY.GOOGLE_CALLBACK];
  const query = useQuery(queryKey, () =>
    handleRequest(AuthControllerService.authControllerGoogleCallback())
  );
  return {
    ...query,
  };
};

export const useLogin = () => {
  const { handleRequest } = useApiService();
  const queryClient = useQueryClient();
  const mutation = useMutation(
    (requestData: LoginRequest) =>
      handleRequest(AuthControllerService.authControllerLogin(requestData)),
    {
      onSuccess: (response) => {
        console.log("User logged in successfully:", response);
        queryClient.invalidateQueries(QUERY.USER_DATA);
      },
    }
  );
  return {
    ...mutation,
  };
};

// Hook for Email Verification
export const useVerifyEmail = (token: string) => {
  const { handleRequest } = useApiService();
  const queryKey = [QUERY.VERIFY_EMAIL, token];
  const query = useQuery(queryKey, () =>
    handleRequest(AuthControllerService.authControllerVerifyEmail(token))
  );
  return {
    ...query,
  };
};

export const useGetMyProfile = () => {
  const { handleRequest } = useApiService();
  const queryKey = [QUERY.GET_MY_PROFILE];

  const query = useQuery(queryKey, () =>
    handleRequest(AuthControllerService.authControllerGetMyProfile())
  );

  return {
    ...query,
  };
};

// export const useGenerateOtp = () => {
//   const { handleRequest } = useApiService();

//   const mutation = useMutation(
//     (requestBody: { email: string; password: string }) =>
//       handleRequest(
//         AuthControllerService.authControllerGenerateOtp(requestBody)
//       ),
//     {
//       onSuccess: (response) => {
//         console.log("OTP sent successfully:", response);
//       },
//       onError: (error) => {
//         console.error("Error generating OTP:", error);
//       },
//     }
//   );

//   return {
//     ...mutation,
//   };
// };

// export const useVerifyOtp = () => {
//   const { handleRequest } = useApiService();

//   const mutation = useMutation(
//     (requestBody: { email: string; otp: string }) =>
//       handleRequest(AuthControllerService.authControllerVerifyOtp(requestBody)),
//     {
//       onSuccess: (response) => {
//         console.log("OTP verified successfully:", response);
//       },
//       onError: (error) => {
//         console.error("Error verifying OTP:", error);
//       },
//     }
//   );

//   return {
//     ...mutation,
//   };
// };

export const useChangePassword = () => {
  const { handleRequest } = useApiService();

  const mutation = useMutation(
    (requestBody: {
      email: string;
      oldPassword: string;
      newPassword: string;
    }) =>
      handleRequest(
        AuthControllerService.authControllerChangePassword(requestBody)
      ),
    {
      onSuccess: (response) => {
        console.log("Password changed Successfully", response);
      },
      onError: (error) => {
        console.error("Error changing password:", error);
      },
    }
  );

  return {
    ...mutation,
  };
};

export const useForgetPassword = () => {
  const { handleRequest } = useApiService();

  const mutation = useMutation(
    (requestBody: { email: string }) =>
      handleRequest(
        AuthControllerService.authControllerForgotPassword(requestBody)
      ),
    {
      onSuccess: (response) => {
        console.log("Reset mail sent successfully:", response);
      },
      onError: (error) => {
        console.error("Error sending reset mail:", error);
      },
    }
  );

  return {
    ...mutation,
  };
};
export const useResetPassword = () => {
  const { handleRequest } = useApiService();

  const mutation = useMutation(
    (requestBody: { resetToken: string; newPassword: string }) =>
      handleRequest(
        AuthControllerService.authControllerResetPassword(requestBody)
      ),
    {
      onSuccess: (response) => {
        console.log("Password reset successfully:", response);
      },
      onError: (error) => {
        console.error("Error reseting password:", error);
      },
    }
  );

  return {
    ...mutation,
  };
};

interface UpdateUserInput {
  userId?: string;
  name?: string;
  photo?: Blob;
  signature?: Blob;
}

export const useUpdateUser = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    async ({ userId, name, photo, signature }: UpdateUserInput) => {
      const updateData = {
        name: name,
        photo: photo,
        signature: signature,
      };

      return UserUpdateControllerService.userUpdateControllerUpdateUser(
        userId,
        updateData
      );
    },
    {
      onSuccess: (response) => {
        console.log("User updated successfully:", response);
        queryClient.invalidateQueries(QUERY.GET_MY_PROFILE);
      },
      onError: (error) => {
        console.error("Error updating user:", error);
      },
    }
  );

  return mutation;
};
